import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'gatsby';
import React from 'react';
import { showUserMessages } from '../../../app/redux/actions/userMatchActions';
import { useAppDispatch } from '../../../app/redux/hooks';

export const MatchMessageNotification = ({ contentType }: { contentType: string }) => {
  if (!contentType) return <></>;
  const isFollow = contentType === 'organisation' || contentType === 'education_provider';

  let message = '';

  if (isFollow) {
    message = `followed! find me in your dashboard`;
  } else {
    message = 'saved! review me in your dashboard';
  }
  const dispatch = useAppDispatch();
  const linkClicked = () => {
    dispatch(showUserMessages(false));
  };
  return (
    <Link
      to="/dashboard/saved"
      data-cy={`link:view-account`}
      className="uppercase bg-shock-700 inline-flex mb-2 px-3 py-1 rounded-lg space-x-1.5 items-center mt-2 mr-2 flex-shrink-0 text-xxs font-semibold"
      onClick={linkClicked}
    >
      {message}
      <span slot="iconRight">
        <FontAwesomeIcon icon={['far', 'arrow-right']} className={`ml-1 w-3`} />
      </span>
    </Link>
  );
};
